<template>
    <section id="default-page">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2>
                        Accept Terms and Conditions
                    </h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div>
                        To continue using the site please accept these <a href="/files/SBLTerms.pdf" target="_blank">terms and conditions</a>
                    </div>
                    <messages :messages="messages"/>
                    <div class="mt-3">
                        <b-btn variant="success" @click="accept">Accept terms</b-btn>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import {getExceptionErrorMessage} from "../../util/common";

export default {
        created(){
        },
        data() {
            return {
                messages: []
            }
        },
        methods: {
            async accept(){
                try {
                    await this.axios.post(this.$laravelRoute('acceptTermsPost'))
                    window.location = '/'
                } catch (e) {
                    let message = getExceptionErrorMessage(e);
                    this.messages.push({type: 'danger', message});
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/User/AcceptTermsPage.vue